<style lang="less" scoped>
.my-info {
  //width: 880px;
  height: 650px;
  overflow: hidden;

  .loadingNew {
    position: absolute;
    top: 0%;
    left: 35%;
    transform: translate(50%, 50%);
  }

  .saveMes {
    width: 160px;
    margin: 80px auto 0 auto;
    font-size: 20px;
    color: #ffffff;
    border-radius: 30px;
  }

  .title {
    color: #333;
    font-size: 18px;
    border-bottom: 1px solid #f2f2f2;
    text-indent: 30px;
    height: 50px;
    line-height: 50px;
    font-weight: 600;
  }

  .content {
    width: 880px;
    margin: 0 80px;

    .upLoad {
      display: flex;
      padding-top: 20px;

      .textLeft {
        width: 100px;
        height: 30px;
        line-height: 30px;
        margin-top: 20px;
        color: #040506;
        font-size: 18px;
        letter-spacing: 5px;
      }

      .imgSize {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }

      .ant-upload-text {
        width: 100px;
        height: 32px;
        line-height: 32px;
        background-color: #eef4fd;
        border-radius: 4px;
        margin: -7px 0 0 10px;
        .uploadText {
          color: #5a99ef;
          font-size: 16px;
        }
      }
    }
    .nickName {
      display: flex;
      margin-top: 20px;
      .textLeft {
        width: 90px;
        height: 30px;
        line-height: 30px;
        margin-top: 20px;
        color: #040506;
        font-size: 18px;
        letter-spacing: 5px;
      }
      .reNameInput {
        margin-top: 20px;
        width: 230px;
        font-size: 16px;
      }
    }
    .sexChange {
      display: flex;
      margin-top: 10px;
      .textLeft {
        width: 90px;
        height: 30px;
        line-height: 30px;
        margin-top: 20px;
        color: #040506;
        font-size: 18px;
        letter-spacing: 5px;
      }
      .select {
        margin-top: 24px;
      }
    }
  }
}
/deep/.anticon svg {
  display: none !important;
}
/deep/.ant-upload.ant-upload-select-picture-card {
  width: 200px !important;
  height: 32px !important;
  border: none !important;
  background-color: #fff !important;
  position: relative;
}
/deep/.ant-upload.ant-upload-select-picture-card > .ant-upload {
  vertical-align: sub !important;
}
.ant-upload-text {
  position: absolute;
  left: 100px;
  top: 30px;
}
.imgInfo {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: absolute;
  left: 0px;
  object-fit: cover;
}
</style>

<template>
  <div class="my-info">
    <div class="title">个人信息</div>
    <div class="content">
      <div class="upLoad">
        <span class="textLeft">头像:</span>
        <!-- <img class="imgSize" :src="$userINfoBasePath+this.photo" /> -->
        <a-upload name="avatar" list-type="picture-card" class="avatar-uploader" :show-upload-list="false"
                  action="" :before-upload="beforeUpload" @change="handleChange">
          <img class="imgInfo" :src="imageUrl"/>
          <div>
            <a-icon :type="loading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">
              <span class="uploadText">更换头像</span>
            </div>
          </div>
        </a-upload>
      </div>
      <div class="nickName">
        <span class="textLeft">帐号:</span>
        <span class="reNameInput"> {{ account }}</span>
      </div>
      <div class="nickName">
        <span class="textLeft">昵称:</span>
        <a-input class="reNameInput" placeholder="请输入昵称" v-model="name"/>
      </div>
      <div class="sexChange">
        <span class="textLeft">性别:</span>
        <div class="select">
          <template>
            <a-radio-group v-model="value" @change="onChange">
              <a-radio :value="1">男</a-radio>
              <a-radio :value="0">女</a-radio>
            </a-radio-group>
          </template>
        </div>
      </div>
    </div>
    <div class="saveMes">
      <a-button type="primary" size="large" @click="saveMes" :disabled="disable==false" block>
        保存
      </a-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import shareState from 'utils/shareState.js'
import md5 from '../../utils/md5.js'
import { CLIENT_ID, CLIENT_SECRET } from '../../utils/authClient.js'
import { JSEncrypt } from 'jsencrypt'
import request from '../../utils/requestUrl'
const CryptoJS = require('crypto-js')

function getBase64 (img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
export default {
  name: 'MyInfo',
  data () {
    return {
      myInfo: '',
      photo: '',
      account: shareState.state.email || this.$getUserInfo().email || this.$getUserInfo().email || this.$getUserInfo().loginName,
      name: this.$store.getters.userInfo.name || shareState.state.name || this.$getUserInfo().name,
      loading: false,
      imageUrl: '',
      value: this.$store.getters.userInfo.gender || this.$getUserInfo().gender,
      uploadUrl: '',
      loadingNew: false,
      disable: false,
      token: '',
      encryptionKey: '',
      userMess: {},
      mrPhoto: require('../../assets/imgs/teacher.png')
    }
  },
  watch: {
    name: function (e) {
      // 修改昵称
      if (e) {
        this.disable = true
        shareState.setUserName(e)
      }
    },
    value: function (val) {
      // 修改性别
      if (val) {
        this.disable = true
      //  shareState.setUserGender(val)
      }
    }
  },
  methods: {
    handleChange (info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl
          this.loading = false
        })
      }
    },
    beforeUpload (file) {
      this.loadingNew = true
      const formData = new FormData()
      formData.append('file', file)
      formData.append('customDir', 'hytc_ebook_server/file')
      formData.append('access_token', this.token || '')
      // 上传图片方法
      const _this = this
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 > 1
      if (isLt2M) {
        _this.$message.error('请您上传小于1M图片！')
      } else if (!isJpgOrPng) {
        _this.$message.error('请您上传jpg、png或jpeg格式图片！')
      } else {
        axios({
          url: _this.$userINfoUploadUrl,
          method: 'post',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then((res) => {
          if (res && res.status === 200) {
            _this.loadingNew = false
            _this.$message.success('更换头像成功')
            _this.disable = true
            _this.uploadUrl = res.data.url
            _this.imageUrl = _this.$userINfoBasePath + '/' + res.data.url
            shareState.setUserPhoto(_this.imageUrl)
            _this.$store.commit('setUserPhoto', _this.imageUrl)
          }
        })
      }
    },
    onChange (e) {
      // gender筛选按钮
      shareState.setUserGender(e.target.value)
      this.value = e.target.value
    },
    getUserInfo1 () {
      // 获取服务器最新的用户信息
      this.imageUrl = shareState.state.userPhoto
      if (!this.imageUrl) {
        this.imageUrl = this.$getUserInfo().photo
          ? this.$userINfoBasePath + '/' + this.$getUserInfo().photo
          : 'imgs/teacher.png'
        shareState.setUserPhoto(this.imageUrl)
      }

      this.id = this.$getUserInfo().id
      const _this = this
      const param = {
        userId: _this.id
      }
      const sign = md5.paramMd5(param, 'client_secret', CLIENT_SECRET)
      param.sign = sign
      // 生成随机密钥
      const random = CryptoJS.lib.WordArray.random(24)
      const keyBase64 = CryptoJS.enc.Base64.stringify(random)
      // 加密参数encryptionKey--使用RSA加密算法
      const encrypt = new JSEncrypt()
      encrypt.setPublicKey(_this.encryptionKey)
      const key = encrypt.encrypt(keyBase64)
      // 加密参数encryptionData--对称加密AES
      const data = _this.aesEncrypt_EBC(JSON.stringify(param), keyBase64)
      const encrypParam = {}
      encrypParam.encryptionKey = key
      encrypParam.encryptionData = data
      encrypParam.access_token = localStorage.getItem('access_token')
      axios({
        url: this.$loginServer + request.getUserInfoByUserId,
        method: 'POST',
        data: encrypParam
      }).then((res) => {
        if (res && res.data.resultCode === '0' && res.data.success === true) {
          // 解密参数
          const jsonString = _this.aesDecrypt_EBC(res.data.resultData.encryptionData, keyBase64)
          const decryptedData = JSON.parse(jsonString)
          console.log('decryptedData', decryptedData)
          // console.log(res)
          _this.$store.commit('setUser_Info', decryptedData)
          _this.userMess = decryptedData
          // _this.imageUrl = _this.userMess.photo&&_this.userMess.photo!=null ? _this.$userINfoBasePath + '/' + _this.userMess.photo: this.mrPhoto
          console.log('getUserInfo1-name1', this.$store.getters.userInfo.name)
          console.log('getUserInfo1-name2', shareState.state.name)
          console.log('getUserInfo1-name3', this.$getUserInfo().name)
          console.log('getUserInfo1-name4', this.$getUserInfo())
          console.log('getUserInfo1-name5', JSON.stringify(decryptedData))
          // 更新本地存储
          localStorage.setItem('user_info', JSON.stringify(decryptedData));
          // setUserInfo(Object.assign(res.data.resultData.user, {
          //   user: [],
          //   class:[],
          //   access_token: res.data.resultData.tokenInfo.access_token
          // }))

          shareState.setUserPhoto(_this.imageUrl)
          shareState.setUserGender(_this.imageUrl)
          _this.$store.commit('setUserPhoto', _this.imageUrl)
          if (res && res.resultData) {
            _this.name = decryptedData.name
            _this.value = decryptedData.gender
          }
        }
      })

      // const param = {
      //   access_token: localStorage.getItem('access_token'),
      //   userId: this.$getUserInfo().id
      // }
      // const _this = this
      // _this
      //   .$fetch({
      //     url: _this.$baseUrl + 'ebook/personal/user/getUserInfoByUserId',
      //     body: param
      //   })
      //   .loading(
      //     () => (_this.loadingNew = true),
      //     () => (_this.loadingNew = false)
      //   )
      //   .done((res) => {
      //     _this.$store.commit('setUser_Info', res.resultData)
      //     _this.userMess = res.resultData
      //     // _this.imageUrl = _this.userMess.photo&&_this.userMess.photo!=null ? _this.$userINfoBasePath + '/' + _this.userMess.photo: this.mrPhoto
      //
      //     shareState.setUserPhoto(_this.imageUrl)
      //     _this.$store.commit('setUserPhoto', _this.imageUrl)
      //     if (res && res.resultData) {
      //       _this.name = res.resultData.name
      //       _this.value = res.resultData.gender
      //     }
      //   })
    },
    /**
     * 更新用户信息
     */
    saveMes () {
      const _this = this
      const param = {
        client_id: CLIENT_ID,
        id: this.$getUserInfo().id,
        name: this.name,
        photo: this.uploadUrl || this.userMess.photo || '',
        gender: this.value
      }
      console.log(param)
      const sign = md5.paramMd5(param, 'client_secret', CLIENT_SECRET)
      param.sign = sign
      // 生成随机密钥
      const random = CryptoJS.lib.WordArray.random(24)
      const keyBase64 = CryptoJS.enc.Base64.stringify(random)
      // 加密参数encryptionKey--使用RSA加密算法
      const encrypt = new JSEncrypt()
      encrypt.setPublicKey(_this.encryptionKey)
      const key = encrypt.encrypt(keyBase64)
      // 加密参数encryptionData--对称加密AES
      const data = _this.aesEncrypt_EBC(JSON.stringify(param), keyBase64)
      const encryParam = {}
      encryParam.encryptionKey = key
      encryParam.encryptionData = data
      encryParam.access_token = localStorage.getItem('access_token')
      axios({
        url: this.$loginServer + request.updateUserInfo,
        method: 'POST',
        data: encryParam
      }).then((res) => {
        if (res && res.data.resultCode === '0' && res.data.success === true) {
          // 解密参数
          const jsonString = _this.aesDecrypt_EBC(res.data.resultData.encryptionData, keyBase64)
          const decryptedData = JSON.parse(jsonString)
          console.log('decryptedData', decryptedData)
          this.$message.success('保存成功')
          this.disable = false
          shareState.setUserName(_this.name)
          shareState.setUserGender(_this.value)
          console.log('user_info', JSON.stringify(jsonString))
          console.log('user_info1', JSON.stringify(decryptedData))
          // localStorage.setItem('user_info', JSON.stringify(decryptedData))
          // this.$store.commit('setUser_Info', decryptedData)
          // this.$store.commit('setUserPhoto', this.$userINfoBasePath+'/'+res.data.resultData.photo)
          _this.getUserInfo1()
          this.$forceUpdate()
          // this.$router.go(0)
        }
      })

      // mobileUser/clientUpdateUserInfo
      // const param = {
      //   access_token: localStorage.getItem('access_token'),
      //   userId: this.id,
      //   name: this.name,
      //   email: '',
      //   phone: '',
      //   photo: this.uploadUrl || this.userMess.photo,
      //   gender: this.value
      // }
      // axios({
      //   url: this.$baseUrl + 'ebook/personal/user/updateUserInfo',
      //   method: 'POST',
      //   data: param
      // }).then((res) => {
      //   if (res && res.data.resultCode === 0 && res.data.success === true) {
      //     this.$message.success('保存成功')
      //     this.disable = false
      //     localStorage.setItem('user_info', JSON.stringify(res.data.resultData))
      //     this.$store.commit('setUser_Info', res.data.resultData)
      //     // this.$store.commit('setUserPhoto', this.$userINfoBasePath+'/'+res.data.resultData.photo)
      //     this.$forceUpdate()
      //   }
      // })

      // const param = {
      //   id: this.id,
      //   photo: this.uploadUrl,
      //   name: this.name,
      //   description: '',
      //   gender: this.value
      // }
      // const _this = this
      // _this.$fetch({
      //   url: _this.$baseUrl + 'ebook/personal/user/updateUserInfo',
      //   body: param
      // }).loading(
      //   () => (_this.loadingNew = true),
      //   () => (_this.loadingNew = false)
      // ).done( res => {
      //     if (res && res.resultCode === 0 && res.success === true) {
      //       _this.$message.success(res.resultMessage)
      //       _this.disable = false
      //      localStorage.setItem('user_info',JSON.stringify(res.resultData))
      //     }
      //   })
    },
    getPublicSecret () {
      // 获取加密公钥
      const _this = this
      axios({
        url: this.$loginServer + 'auth/res/getPublicSecret'
      }).then((res) => {
        console.log(res)
        if (res && res.data && res.data.resultCode === '0') {
          _this.encryptionKey = res.data.resultData
          // console.log(_this.encryptionKey)
          _this.getUserInfo1()
        }
      })
    },
    aesEncrypt_EBC: function (word, keySec) {
      // aes加密
      const aeskey = CryptoJS.enc.Utf8.parse(keySec)
      const srcs = CryptoJS.enc.Utf8.parse(word)
      const encrypted = CryptoJS.AES.encrypt(srcs, aeskey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
      return encrypted.ciphertext.toString()
    },
    aesDecrypt_EBC: function (word, keySec) {
      // aes解密
      const aeskey = CryptoJS.enc.Utf8.parse(keySec)
      const encryptedHexStr = CryptoJS.enc.Hex.parse(word)
      const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
      const decrypt = CryptoJS.AES.decrypt(srcs, aeskey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
      const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
      return decryptedStr.toString()
    }
  },
  mounted () {
    this.token = localStorage.getItem('access_token')
    this.getPublicSecret()
    // this.getUserInfo1()
  }
}
</script>
